module.exports = __webpack_public_path__ + "img/bg-blog-sec1-dark.0525d2c1.png";